import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

const HelpItem = styled.div`
  position: relative;
  padding: 0 25px;
`

HelpItem.Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

HelpItem.Icon = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 2.4rem 0rem 2.4rem 0;

  & > div,
  & > div > div {
    display: flex;
    align-items: center;
  }
`

HelpItem.Heading = styled.div`
  flex-shrink: 0;
  font-weight: 600;
  font-size: 1.4rem;
  padding: 2.4rem 2.4rem 2.4rem 0;
  color: #d5d9e2;
  transition: width 0.5s;
`

export { HelpItem }